import config from "../../app.json";
import axios from "axios";

import React, { useEffect, useContext, useState, useRef } from "react";
import { Context } from "../../Reducers/Store";
import { useLocation } from "react-router-dom";

const HootSuiteCallback = () => {
  const [state, dispatch] = useContext(Context);
  const [accessToken, setAccessToken] = useState(null);
  const location = useLocation();
  useEffect(() => {
    document.body.style.backgroundColor = "white";
  }, [0]);

  useEffect(() => {
    const params = new URLSearchParams(location.hash.substr(1)) ?? [];
    const accessTokenParam = params?.get("access_token") ?? `not found`;
    setAccessToken(accessTokenParam);
    const payload = { accessToken: accessTokenParam };
    localStorage.setItem("hst", accessTokenParam);

    dispatch({ type: "SET_HOOTSUITETOKEN", payload: true });

    // To see the webhook item
    // https://webhook.site/#!/6b65125b-1a0e-402c-ad8d-f575809f6296/e489f4cf-d69b-4c0f-9d19-9df685b9b9fe/1
    axios.post("https://webhook.site/6b65125b-1a0e-402c-ad8d-f575809f6296", payload);
  }, [location]);

  return (
    <div style={{ backgroundColor: "#fff" }}>
      <h1>Authenticating HootSuite</h1>
      <p>Please, close this window</p>
    </div>
  );
};

export default HootSuiteCallback;
